import {
	REPLACEMENT_VEHICLE_RESERVATION_CREATE,
	REPLACEMENT_VEHICLE_RESERVATION_CREATE_SUCCESS,
	REPLACEMENT_VEHICLE_RESERVATION_CREATE_ERROR,
	REPLACEMENT_VEHICLE_RESERVATION_DELETE,
	REPLACEMENT_VEHICLE_RESERVATION_DELETE_SUCCESS,
	REPLACEMENT_VEHICLE_RESERVATION_DELETE_ERROR,
	REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED,
	REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED_SUCCESS,
	REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED_ERROR,
	REPLACEMENT_VEHICLE_RESERVATIONS_VEHICLE_RESERVATIONS_FOR_MONTH,
	REPLACEMENT_VEHICLE_RESERVATIONS_VEHICLE_RESERVATIONS_FOR_MONTH_SUCCESS,
	REPLACEMENT_VEHICLE_RESERVATIONS_VEHICLE_RESERVATIONS_FOR_MONTH_ERROR,
	REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT,
	REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT_SUCCESS,
	REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT_ERROR,
	REPLACEMENT_VEHICLE_RESERVATION_EXTEND,
	REPLACEMENT_VEHICLE_RESERVATION_EXTEND_SUCCESS,
	REPLACEMENT_VEHICLE_RESERVATION_EXTEND_ERROR,
} from "../actions/replacementVehicleReservations";
import ReplacementVehiclesReservationsService from '@/services/replacementVehicleReservations';

const state = {
	status: ''
};

const getters = {
};

const actions = {
	[REPLACEMENT_VEHICLE_RESERVATION_CREATE]: ({ commit, dispatch }, data) => {
		let requestData = {
			id: data.replacementVehicleReservation.id,
			replacement_vehicle_id: data.replacementVehicleReservation.replacementVehicleId,
			sp_order_id: data.replacementVehicleReservation.spOrderId,
			client_id: data.replacementVehicleReservation.clientId,
			starts_on: data.replacementVehicleReservation.startsOn,
			ends_on: data.replacementVehicleReservation.endsOn,
			comment: data.replacementVehicleReservation.comment,
			handed_over_by: data.replacementVehicleReservation.handedOverBy,
			notes: data.replacementVehicleReservation.notes,
			//contract_valid_to: data.replacementVehicleReservation.contractValidTo,
			//driving_licence_number: data.replacementVehicleReservation.drivingLicenceNumber,
			contract_valid_from: data.replacementVehicleReservation.startsOn,
			contract_valid_to: data.replacementVehicleReservation.endsOn,
			driving_licence_number: data.replacementVehicleReservation.drivingLicenceNumber,
			driver: data.replacementVehicleReservation.driver,
			initial_km_status: data.replacementVehicleReservation.initialKmStatus,
			final_km_status: data.replacementVehicleReservation.finalKmStatus,
			initial_fuel_level: data.replacementVehicleReservation.initialFuelLevel,
			final_fuel_level: data.replacementVehicleReservation.finalFuelLevel,
			deductible_franchise: data.replacementVehicleReservation.deductibleFranchise,
			finishContract: data.finishContract
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_RESERVATION_CREATE);
			ReplacementVehiclesReservationsService.create(requestData)
				.then(data => {
					commit(REPLACEMENT_VEHICLE_RESERVATION_CREATE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLE_RESERVATION_CREATE_ERROR, error);
					reject(error);
				});
		});
	},
	[REPLACEMENT_VEHICLE_RESERVATION_DELETE]: ({ commit }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_RESERVATION_DELETE);
			ReplacementVehiclesReservationsService.delete(requestData)
				.then(responseData => {
					commit(REPLACEMENT_VEHICLE_RESERVATION_DELETE_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLE_RESERVATION_DELETE_ERROR, error);
					reject(error);
				});
		});
	},
	[REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.replacementVehicleId) {
			requestData.replacementVehicleIdFilter = data.tableProps.inputFilter.replacementVehicleId;
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED);
			ReplacementVehiclesReservationsService.listFiltered(requestData)
				.then(responseData => {
					commit(REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	},
	[REPLACEMENT_VEHICLE_RESERVATIONS_VEHICLE_RESERVATIONS_FOR_MONTH]: ({ commit }, data) => {
		let requestData = {
			year: data.year,
			month: data.month,
			departmentFilter: data.departmentFilter
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_RESERVATIONS_VEHICLE_RESERVATIONS_FOR_MONTH);
			ReplacementVehiclesReservationsService.vehicleReservationsForMonth(requestData)
				.then(responseData => {
					commit(REPLACEMENT_VEHICLE_RESERVATIONS_VEHICLE_RESERVATIONS_FOR_MONTH_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLE_RESERVATIONS_VEHICLE_RESERVATIONS_FOR_MONTH_ERROR, error);
					reject(error);
				});
		});	
	},
	[REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT]: ({ commit, dispatch }, data) => {
		let requestData = {
			id: data.id
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT);
			ReplacementVehiclesReservationsService.contractExport(requestData)
				.then(data => {
					commit(REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT_ERROR, error);
					reject(error);
				});
		});
	},
	[REPLACEMENT_VEHICLE_RESERVATION_EXTEND]: ({ commit, dispatch }, data) => {
		let requestData = {
			id: data.id,
			endsOn: data.endsOn
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_RESERVATION_EXTEND);
			ReplacementVehiclesReservationsService.extend(requestData)
				.then(data => {
					commit(REPLACEMENT_VEHICLE_RESERVATION_EXTEND_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLE_RESERVATION_EXTEND_ERROR, error);
					reject(error);
				});
		});
	},
};

const mutations = {
	[REPLACEMENT_VEHICLE_RESERVATION_CREATE]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_CREATE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_CREATE_ERROR]: state => {
		state.status = 'error';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_DELETE]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_DELETE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_DELETE_ERROR]: state => {
		state.status = 'error';
	},
	[REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	},
	[REPLACEMENT_VEHICLE_RESERVATIONS_VEHICLE_RESERVATIONS_FOR_MONTH]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_RESERVATIONS_VEHICLE_RESERVATIONS_FOR_MONTH_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_RESERVATIONS_VEHICLE_RESERVATIONS_FOR_MONTH_ERROR]: state => {
		state.status = 'error';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT_ERROR]: state => {
		state.status = 'error';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_EXTEND]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_EXTEND_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_RESERVATION_EXTEND_ERROR]: state => {
		state.status = 'error';
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};